import PropTypes from 'prop-types';
import React from 'react';

import {NewLookTheme} from 'web-app/styleguide/themes';

import {type IconProps} from '../icon-props';
import {G, SVG} from '../svg';
import {type IconComponent} from './icon-component';

/**
 * @deprecated use MF icons
 */
export const Error: IconComponent<IconProps> = ({fill, ...rest}) => (
    <SVG viewBox="0 0 24 24" {...rest}>
        <G fill={fill}>
            <path d="M19.216,17.4644999 L12.882,5.58949994 C12.506,4.88349994 11.494,4.88349994 11.117,5.58949994 L4.784,17.4644999 C4.429,18.1304999 4.912,18.9354999 5.667,18.9354999 L18.334,18.9354999 C19.088,18.9354999 19.571,18.1304999 19.216,17.4644999 Z M12,16.9354999 C11.448,16.9354999 11,16.4874999 11,15.9354999 C11,15.3834999 11.448,14.9354999 12,14.9354999 C12.552,14.9354999 13,15.3834999 13,15.9354999 C13,16.4874999 12.552,16.9354999 12,16.9354999 Z M13,13.9354999 L11,13.9354999 L11,9.93549994 L13,9.93549994 L13,13.9354999 Z" />
        </G>
    </SVG>
);
Error.propTypes = {
    fill: PropTypes.string,
};
Error.defaultProps = {
    fill: NewLookTheme.text,
};
Error.isPrivate = true;
export default Error;
